
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 18 20"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#555","d":"M17 2V1c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V4c0-2.21-1.79-4-4-4S2 1.79 2 4v7H1c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H4V4c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4V7h1c.55 0 1-.45 1-1V2z","transform":"translate(-0.5 -0.5)"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  